import React from 'react'

import { Form, Col } from '_zari/core'

const FlagGenerarNuevoCorrelativoFormGroup = ({ checked, onChange }) => {
  return (
    <Form.Group>
      <Col md={8}>
        <Form.Checkbox
          checked={checked}
          onChange={onChange}
          id='checkbox-flagGenerarNuevoCorrelativo'
          label='Generar nuevo correlativo'
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagGenerarNuevoCorrelativoFormGroup)
